// Path: src\Components\Legality\TermsAndCondition.jsx
import { React, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import BaseHome from "../Home/BaseHome";
import { privacyPolicyPage, termsNConditionPage } from "../../api/public.api";
import { t } from "i18next";
import ListLoader from '../Common/ListLoader';
const TermsOfUse = () => {
  const navigate = useNavigate();
  const [terms, setTerms] = useState("");
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    fetchTerms();
  }, [])
  const fetchTerms = async () => {
    try { 
      setLoading(true);
      const response = await termsNConditionPage();
      setLoading(false);
      if (response?.success && response?.data) {
        setTerms(response?.data?.description)
      } 
    }
    catch (error) {
      setLoading(false);
    }
  };

  return (
    <BaseHome title={t("moreMenu.term_of_use")} onBackClick={() => navigate(-1)}>
      {!isLoading ? terms.trim() !== '' ? <>
        <div className="page-rules-list private-scrims-manage-rules-height-update" dangerouslySetInnerHTML={{ __html: terms }} />
      </> : <>

      {/* <div className="d-flex justify-content-center align-items-center" style={{height:"100vh"}}>  */}
      <div className="no-record-found-center">{t("common.no_data_found")}</div>
      {/* </div> */}
      </>:<> {isLoading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>}</>}
    </BaseHome>
  );
};

export default TermsOfUse;
